import { useAuth } from '@/contexts'
import { useQuery } from '@tanstack/react-query'

export const useUserTransactions = () => {
    const baseUrl = `${import.meta.env.VITE_API_URL}/api/users/`

    const { getAccessToken, session, user } = useAuth()
    const transactions = useQuery({
        queryKey: ['transactions', user?.id],
        queryFn: async () => {
            const response = await fetch(`${baseUrl}${user?.id}/transactions`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: (await getAccessToken()) || '',
                },
            })

            if (!response.ok) {
                throw new Error(response.statusText)
            }
            return response.json()
        },
        enabled: !!session && !!user?.id,
    })

    return {
        isLoading: transactions.isLoading,
        transactions: transactions.data || [],
    }
}
